import styled from 'styled-components';
import { palette } from '@solvhealth/jigsaw-v1';
import { colors } from '../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../constants/text';
import { media } from '~/core/util/styledComponents';

export const AnchorTag = styled.a.withConfig({ componentId: 'sc-1inqnvy-0' })`
  display: block;
  position: relative;
  top: -100px;
  // currently this is inheriting margin from a Stack and ruining the layout
  // TODO: since this supposed to be an invisible elment, see if there is another way
  // to render it w/o giving it size and margin
  margin-bottom: 0px !important;
`;

export const PanelSection = styled.div.withConfig({ componentId: 'sc-1inqnvy-1' })`
  border-top: 1px solid ${colors.dorianGrey};
  padding-top: 32px;
  padding-bottom: 32px;
`;

export const StyledText = styled.div.withConfig({ componentId: 'sc-1inqnvy-2' })`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.default};
  line-height: 24px;
  color: ${colors.squid};
`;

export const StyledBody = styled(StyledText).withConfig({ componentId: 'sc-1inqnvy-3' })`
  font-size: ${fontSize.mediumSmall};
`;

// TODO: refactor fontSize constants (hellaLarge vs. helzaLarge?)
export const StyledSubtext = styled(StyledText).withConfig({ componentId: 'sc-1inqnvy-4' })`
  font-size: ${fontSize.small};
  color: ${palette.gray[500]};
  line-height: 16px;
  :not(:last-child) {
    padding-bottom: 8px;
  }
`;

export const StyledUl = styled.ul.withConfig({ componentId: 'sc-1inqnvy-5' })`
  margin: 0;
`;

export const StyledSpanBody = styled.span.withConfig({ componentId: 'sc-1inqnvy-6' })`
  color: ${palette.crunchberry.base};
  cursor: pointer;
  font-size: ${fontSize.mediumSmall};
`;

export const Container = styled.div.withConfig({ componentId: 'sc-1inqnvy-7' })`
  margin-bottom: 24px;

  && .root {
    box-shadow: none;
    border: 1px solid ${palette.gray[200]};
    border-radius: 8px;
  }

  && .summary-root {
    padding: 10px 24px;

    ${media.customWidth(403)} {
      padding: 10px 8px;
    }
  }

  && .summary-content {
    display: block;
  }

  && .summary-expanded {
    padding-bottom: 0;
  }

  && .details-root {
    display: block;
    padding: 8px 24px 20px 24px;

    ${media.customWidth(403)} {
      padding: 8px 8px 20px 8px;
    }
  }
`;

export const StyledBadge = styled.div.withConfig({ componentId: 'sc-1inqnvy-8' })`
  margin-left: 16px;
  width: 106px;
  height: 24px;
  background: ${colors.purpleTesting};
  border-radius: 4px;
  color: ${colors.purplexed};
  font-size: 14px;
  line-height: 25px;
  text-align: center;

  ${media.phonePlusWidth} {
    margin-left: 0;
    margin-bottom: 16px;
  }
`;
